
// 判断是否是PC
export const isPC = () => {
  const userAgent = navigator.userAgent
  const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"]
  let flag = true
  for (let i = 0; i < agents.length; ++i) {
    if (userAgent.indexOf(agents[i]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

export const pad = n => n < 10 ? `0${n}` : `${n}`

// 获取Date的年月日时分秒
export const detailDate = (d) => {
  const year = d.getFullYear()
  const month = pad(d.getMonth() + 1)
  const date = pad(d.getDate())
  const hours = pad(d.getHours())
  const minutes = pad(d.getMinutes())
  const seconds = pad(d.getSeconds())

  return {
    year,
    month,
    date,
    hours,
    minutes,
    seconds
  }
}

// 格式化时间
// 2022-05-23T18:44:54.328 格式化成 yyyy-MM-dd HH:mm:ss
export const formatDate = (str) => {
  const { year, month, date, hours, minutes, seconds } = detailDate(new Date(str))
  return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`
}

